/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum NotificationParameterFlags {
  None = 'None',
  Animation = 'Animation',
  Enquete = 'Enquete',
  AlerteSolde = 'AlerteSolde',
  Paiement = 'Paiement',
  Favoris = 'Favoris',
  DinerTakeAway = 'DinerTakeAway',
  ResultatVote = 'ResultatVote',
  Commande = 'Commande',
  Echange = 'Echange',
  AntiGaspi = 'AntiGaspi',
  All = 'ALL',
}
